@if (model?.period && selectedPremium) {
  <div class="summaryDiv">
    @if (selectedPremium.total>0) {
      <mat-card appearance="outlined">
        <mat-card-content>
          <p>
            La souscription doit être acquittée au plus tard le <strong>{{model.period.effectiveStartDate | date: 'yyyy/MM/dd'}} à 0h01 heure normale de l'est.</strong>.
          </p>
          <p>
            <u><strong>Aucun délai ne sera accordé</strong></u>
          </p>
          <p>
            Sur réception de votre paiement, une preuve d'assurance vous sera acheminée.
          </p>
          <br/>
        </mat-card-content>
      </mat-card>
    }
    <mat-card appearance="outlined">
      <mat-card-header>
        {{ 'shoppingCart.checkout.transactionDetails.title' | translate }}
      </mat-card-header>
      <mat-card-content>
        <table id="summaryTable">
          <thead>
            <th class="summaryDescriptionColumn"></th>
            <th class="summaryValueColumn"></th>
          </thead>
          <tbody>
            <tr>
              <td>
                <div>
                  SOUSCRIPTION OBLIGATOIRE POUR LA PÉRIODE
                  DU <span class="bold">{{model.period.effectiveStartDate | date: 'yyyy/MM/dd'}}</span>
                  AU <span class="bold">{{model.period.effectiveEndDate  | date: 'yyyy/MM/dd'}}  À 0h01 heure normale de l’est.</span>
                </div>
                @if (selectedPremium.userRefuseSurplus) {
                  <div>
                    {{'subscription.form.premium.table.mandatoryBaseAssurance' | translate}}
                    <span class="bold"> {{ selectedPremium.premiumAmount | currencyCustom:0  }}</span>
                  </div>
                }
                @if (!selectedPremium.userRefuseSurplus) {
                  <div>
                    @if (!inactiveMemberForSubscription) {
                      <span> Assurance de </span>
                      <span class="surplusAmountValue">
                        {{  selectedPremium?.premiumAmount | currencyCustom:0 }}
                      </span>
                      <span> par sinistre </span>
                    }
                    @if (inactiveMemberForSubscription) {
                      <span> Assurance excédentaire de  </span>
                      <span class="surplusAmountValue">
                        {{  selectedPremium?.premiumAmountWithoutBase | currencyCustom:0 }}
                      </span>
                      <span> par sinistre  </span>
                    }
                  </div>
                }
              </td>
              <td class="right">
                {{ selectedPremium.premiumBase| currencyCustom }}
              </td>
            </tr>
            @if (!!selectedPremium.credit) {
              <tr>
                <td>{{'subscription.form.premium.table.creditHeader' | translate}}</td>
                <td class="right">{{ selectedPremium.credit | currencyCustom }}</td>
              </tr>
            }
            @if (selectedPremium.subprime>0) {
              <tr>
                <td>{{'subscription.form.premium.table.surpremimumHeader' | translate}}</td>
                <td class="right">{{ selectedPremium.subprime | currencyCustom }}</td>
              </tr>
            }
            <tr>
              <td>{{'subscription.form.premium.table.tpaHeader' | translate}}</td>
              <td class="right">{{ selectedPremium.tpa | currencyCustom }}</td>
            </tr>
            <tr class="bold">
              <td>{{'subscription.form.premium.table.totalHeader'| translate}}</td>
              <td class="right">{{ selectedPremium.total | currencyCustom }}</td>
            </tr>
          </tbody>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
}

